// Props for the Segment Settings > Wallpaper category tab strip
// (Colors / Gradient / Image / SVG Patterns / Loops / Designs / Preset
// wallpapers, flag-gated categories folded in on top of the base three).
//
// BUG-editwheel-b54183: the shared <Tabs> component defaults to MUI's
// `variant="fullWidth"`, which divides the track into N equal-width slices
// regardless of how much room each label actually needs, then renders with
// `text-overflow: clip` (not ellipsis) once a label overflows its slice.
// MEASURED live on web-stg.iyuga.net (Segment Settings > Wallpaper, desktop
// side-pane width) with the default three categories plus the flag-gated
// ones enabled: "Gradient" clipped to "3radien", "SVG Pattern" clipped to
// "SVG attern", "Design" clipped to ")esign", and "Preset wallpapers"
// clipped to " allpape" — every label longer than the ~24px equal-slice
// width lost its leading character(s) (the anti-aliased edge of the clipped
// glyph reads as a stray digit/apostrophe in a screenshot, which is where
// the "3radien" and ")esign" transcriptions in the original report came
// from). Same failure class already fixed once for the Segment Icon category
// strip (iconCategoryTabProps.js, 2026-07-31) — MUI's fullWidth variant is
// fundamentally the wrong choice for a tab strip whose label set can outgrow
// a fixed pane width, flag-gated or not.
//
// Scrollable gives every tab its intrinsic (un-clipped) width and adds scroll
// buttons for the overflow — nothing else about the picker changes.
//
// fix-ew-O3 (2026-09-11): MEASURED live on web-dev.iyuga.net, Segment Settings
// > Wallpaper strip at 1440px: the scroller's own viewport is only 250px wide
// (330px MuiTabs-root minus the two 40px scroll-button icons), while the 7
// category tabs need 623px at the shared <Tabs> component's default per-tab
// padding ("8px 12px" + a 4px flex-gap) — only "Colors | Gradient | Image"
// fit, with "SVG Patterns" cut to 29 of its 110px and "Loops" / "Designs" /
// "Preset wallpapers" entirely offscreen (0px visible each), all reachable
// only via the scroll arrow. The scrollable variant above already guarantees
// every tab is reachable (not the b54183 clipping bug); this narrows how much
// of the strip is hidden behind that arrow by giving back some of the padding
// the default Tab styling spends on a 7-way strip it was never sized for.
//
// fix-ew-o3-wallpaper-tabstrip-clips-svg-patterns (2026-09-11, re-measured):
// even after the padding pass above, 7 tabs still need 555px in a 250px
// scroller viewport (MEASURED live on web-dev.iyuga.net, bundle
// main.929a20d8.js) — MUI's TabsScroller clips its content with a hard
// `overflow: hidden` at the viewport edge, so the tab straddling that edge
// ("SVG Patterns") renders fully laid out (its own scrollWidth ==
// clientWidth, not internally ellipsis-truncated) but gets sliced off
// mid-word by the container boundary itself, with nothing to signal more
// content follows besides the small scroll-button chevron. Same fix already
// blessed for this exact shape of problem elsewhere in the app (a
// "full-bleed rail" with a decorative edge fade instead of a hard clip — see
// ResponsiveSectionNav/styles.js's `Strip` and CreatorAnalytics/HallOfFame.jsx)
// — a right-edge mask-image on the scroller reads the cut tab as an
// intentional "more to scroll" cue rather than a broken render.
//
// vy-0914-ew-wallpaper-strip-left-edge-hard-clip (2026-09-14): MEASURED live
// on web-dev.iyuga.net, bundle main.56132db7.js — the fade above was
// right-edge only, so once the strip scrolls (e.g. selecting "SVG Patterns"
// moves scrollLeft to 43 at 1440px / 163 at 1024px) the tab straddling the
// LEFT edge ("Colors" at 1440px, 14 of its 57px visible; "Image" at 1024px,
// 26 of its 55px visible) hard-clips with no fade, the exact same defect the
// right-edge fix above was meant to eliminate. The right edge only needed a
// fade because it never scrolls away from view, but the left edge starts
// clipped the instant scrollLeft > 0. Fading both edges unconditionally
// (matching this app's existing always-on decorative-fade convention, not a
// scroll-position-conditional one) covers both directions.
const EDGE_FADE_PX = "24px";
const WALLPAPER_TAB_PROPS = {
  variant: "scrollable",
  scrollButtons: "auto",
  allowScrollButtonsMobile: true,
  sx: {
    "& .MuiTab-root": {
      minWidth: "auto",
      padding: "6px 8px",
      fontSize: "13px",
      fontWeight: 500,
    },
    "& .MuiTabs-flexContainer": {
      gap: "2px",
    },
    "& .MuiTabs-scroller": {
      WebkitMaskImage: `linear-gradient(to right, transparent 0, #000 ${EDGE_FADE_PX}, #000 calc(100% - ${EDGE_FADE_PX}), transparent 100%)`,
      maskImage: `linear-gradient(to right, transparent 0, #000 ${EDGE_FADE_PX}, #000 calc(100% - ${EDGE_FADE_PX}), transparent 100%)`,
    },
  },
};

export default WALLPAPER_TAB_PROPS;
